import { cn } from '../lib/utils';
import { useSearch } from '@tanstack/react-router';
import { EntityType, ERefundType } from '../services/direct';
import { useTranslation } from 'react-i18next';
import { Attachments } from './Attachment/Attachments';
import { useRefundDetails } from '../hooks/useRefundDetails';

const Balance = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { data } = useRefundDetails();

  const search = useSearch({ strict: false });

  const {
    refund_amount,
    refund_type,
    business_payee_name = '',
    first_name = '',
    last_name = '',
    entity_type,
    isCustomPaymentTypesEnabled,
  } = data?.refundData || {};

  const payeeName = isCustomPaymentTypesEnabled
    ? entity_type === EntityType.BUSINESS || entity_type === EntityType.UNKNOWN
      ? business_payee_name
      : first_name + ' ' + last_name
    : refund_type === ERefundType.BUSINESS
      ? business_payee_name
      : first_name + ' ' + last_name;
  return (
    <>
      <div
        className={cn(
          'flex items-center justify-between rounded-md border border-border bg-card p-6',
          className,
        )}
      >
        <div className='flex w-full flex-col gap-2'>
          <div className='mb-2 flex items-center justify-between'>
            <div className='flex flex-col'>
              <h4 className='text-base font-bold text-secondary-foreground md:text-xl'>
                {search.paymentType
                  ? t(search.paymentType.replace('+', ' '))
                  : t('Available Balance')}
              </h4>
              <p className='text-base font-bold text-primary'>
                {t('Payee')} - {payeeName}
              </p>
            </div>
            <div className='flex flex-col gap-2 rounded-md bg-primary-600 p-2 md:p-4'>
              <h3 className='flex items-center text-2xl font-bold text-card md:text-3xl'>
                <span>
                  <span>$</span>{' '}
                  {parseFloat(refund_amount ?? '0.00').toFixed(2)}
                </span>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <Attachments attachments={data?.refundData?.files} />
    </>
  );
};

export default Balance;
